import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type fetchSelectsForTestModel = {
  id: number | string
}

export const fetchTest = () => {
  return new ServicesUseCase(`/teste/findAll`, makeAxiosHttpClient())
}

export const fetchSelectsForTest = ({ id }: fetchSelectsForTestModel) => {
  return new ServicesUseCase(
    `/aplicacaoTeste/loadTestes/${id}`,
    makeAxiosHttpClient()
  )
}
